import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AppRole, User } from '../models/user.model';

export interface CreateUserDto {
  email: string;
  password: string;
  fullName?: string | null;
  role: 'admin' | 'user';
}

@Injectable({ providedIn: 'root' })
export class UsersService {
  private http = inject(HttpClient);
  private base = `${environment.apiUrl}/Users`;

  getAll(): Observable<User[]> {
    return this.http.get<User[]>(this.base).pipe(catchError(this.handle));
  }

  getById(id: string): Observable<User> {
    return this.http.get<User>(`${this.base}/${id}`).pipe(catchError(this.handle));
  }

  create(dto: CreateUserDto): Observable<User> {
    return this.http.post<User>(this.base, dto).pipe(catchError(this.handle));
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.base}/${id}`).pipe(catchError(this.handle));
  }

  private handle(err: any) {
    return throwError(() => err);
  }
}
